import { render, staticRenderFns } from "./WizardPhotoBookCard.vue?vue&type=template&id=86e55e7c"
import script from "./WizardPhotoBookCard.vue?vue&type=script&lang=js"
export * from "./WizardPhotoBookCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports